import { BaseListView } from "@/base/BaseListView";
import { definePendingListView } from "@/base/list/defineListView";

// Binders (BRK-S251): a BaseListView page PMS can't serve yet. PMS keeps no
// binder records until bind issues them (PMS-S555); bound coverage shows on its
// submission meanwhile. BRK-S215 wires this list to `GET /api/broker/binders`
// once PMS-S560 ships it; the columns are its.
const BINDERS_LIST = definePendingListView({
  plannedEndpoint: "/api/broker/binders",
  noun: "binders",
  title: "Binders",
  context:
    "Proof of coverage issued at bind, until the carrier issues the policy.",
  columns: [
    "Binder",
    "Carrier",
    "Coverage",
    "Effective",
    "Expires on",
    "Status",
  ],
  notYetAvailable: {
    title: "Binders will be listed here",
    body: "Until then, bound coverage shows on its submission.",
    href: "/submissions",
    linkLabel: "Go to Submissions",
  },
});

export function BindersPage() {
  return <BaseListView def={BINDERS_LIST} />;
}
